/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataCtmsCategoryRespVo } from './PageDataCtmsCategoryRespVo';
import {
    PageDataCtmsCategoryRespVoFromJSON,
    PageDataCtmsCategoryRespVoFromJSONTyped,
    PageDataCtmsCategoryRespVoToJSON,
    PageDataCtmsCategoryRespVoToJSONTyped,
} from './PageDataCtmsCategoryRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataCtmsCategoryRespVo
 */
export interface ResponsePageDataCtmsCategoryRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataCtmsCategoryRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataCtmsCategoryRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataCtmsCategoryRespVo}
     * @memberof ResponsePageDataCtmsCategoryRespVo
     */
    data?: PageDataCtmsCategoryRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataCtmsCategoryRespVo interface.
 */
export function instanceOfResponsePageDataCtmsCategoryRespVo(value: object): value is ResponsePageDataCtmsCategoryRespVo {
    return true;
}

export function ResponsePageDataCtmsCategoryRespVoFromJSON(json: any): ResponsePageDataCtmsCategoryRespVo {
    return ResponsePageDataCtmsCategoryRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataCtmsCategoryRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataCtmsCategoryRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataCtmsCategoryRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataCtmsCategoryRespVoToJSON(json: any): ResponsePageDataCtmsCategoryRespVo {
    return ResponsePageDataCtmsCategoryRespVoToJSONTyped(json, false);
}

export function ResponsePageDataCtmsCategoryRespVoToJSONTyped(value?: ResponsePageDataCtmsCategoryRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataCtmsCategoryRespVoToJSON(value['data']),
    };
}

